import { RoleId } from './role-id.enum';

export class Role {
  id: RoleId;
  name: string;
  roleAssignmentRequiresElevatedPrivileges: boolean;
}
